import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=506f9dad&scoped=true"
import script from "./not-found.ts?vue&type=script&lang=ts&external"
export * from "./not-found.ts?vue&type=script&lang=ts&external"
import style0 from "./not-found.less?vue&type=style&index=0&id=506f9dad&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506f9dad",
  null
  
)

export default component.exports